import { render, staticRenderFns } from "./wy.vue?vue&type=template&id=707cc451"
import script from "./wy.vue?vue&type=script&lang=js"
export * from "./wy.vue?vue&type=script&lang=js"
import style0 from "./wy.vue?vue&type=style&index=0&id=707cc451&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports